<template>
    <div>
        <v-card flat>
            <v-toolbar dense flat rounded>
                <v-toolbar-title>{{ $t("debit_notes") }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <p-icon-btn
                    icon="mdi-eye"
                    tooltip="Open"
                    v-if="hasOnlyOneSelected"
                    @click="openDebitNoteDisplay"
                ></p-icon-btn>
                <p-icon-btn
                    icon="mdi-refresh"
                    tooltip="Refresh"
                    @click="refresh"
                ></p-icon-btn>
                <debit-note-search-menu
                    @submit="handleSearchMenuSubmit"
                    v-model="searchMenuShown"
                    :search.sync="search"
                ></debit-note-search-menu>
                <p-menu :items="menuItems"></p-menu>
            </v-toolbar>
            <v-card-text>
                <debit-notes-data-table
                    ref="debitNoteDataTable"
                    :search="search"
                    v-model="selected"
                >
                </debit-notes-data-table>
            </v-card-text>
        </v-card>
        <debit-note-display
            v-model="debitNoteDisplayShown"
            v-if="debitNoteDisplayShown"
            :debitNote="selectedDebitNote"
            @updated="refresh"
        >
        </debit-note-display>
        <debit-notes-dialog
            v-if="debitNoteDialogShown"
            v-model="debitNoteDialogShown"
            :id="selectedDebitNote.id"
            @updated="refresh"
        >
        </debit-notes-dialog>
        <p-alert
            v-if="alert.display"
            v-model="alert.display"
            :title="alert.title"
            :content="alert.content"
            :callback="alert.callback">
        </p-alert>
    </div>
</template>
<script>
import { isEmpty } from "lodash";

import { deleteDebitNote } from "../../services/sales/debitNote";

import PAlert from '../../components/common/PAlert';
import DebitNotesDataTable from "../../components/Sales/DebitNotesDataTable.vue";
import DebitNoteSearchMenu from "../../components/Sales/DebitNotesSearchMenu.vue";
import DebitNoteDisplay from "../../components/Sales/DebitNoteDisplay";
import DebitNotesDialog from "../../components/Sales/DebitNotesDialog";
import PIconBtn from "../../components/common/PIconBtn.vue";
import PMenu from "../../components/common/PMenu.vue";
export default {
    name: "DebitNotes",
    components: {
        PMenu,
        PIconBtn,
        DebitNotesDataTable,
        DebitNoteSearchMenu,
        DebitNoteDisplay,
        DebitNotesDialog,
        PAlert
    },
    data() {
        return {
            selected: [],
            loading: {},
            debitNotes: [],
            options: {},
            debitNoteDisplayShown: false,
            debitNoteDialogShown: false,
            searchMenuShown: false,
            search: {},
            alert: {}
        };
    },
    computed: {
        menuItems() {
            return [
                {
                    text: "New",
                    icon: "mdi-plus-circle",
                    ability: this.canCreate,
                    callback: this.openDebitNoteDialogCreate,
                },
                {
                    text: "Edit",
                    icon: "mdi-pencil",
                    ability: this.canUpdate,
                    callback: this.openDebitNoteDialogEdit,
                    display: this.hasOnlyOneSelected,
                },
                {
                    text: "Delete",
                    icon: "mdi-delete",
                    ability: this.canDelete,
                    callback: this.confirmDeleting,
                    display: this.hasOnlyOneSelected,
                },
            ];
        },
        canCreate() {
            return true;
            // return authorizations.debit_notes ? !authorizations.debit_notes.create : true;
        },
        canUpdate() {
            return true;
            // return authorizations.debit_notes ? !authorizations.debit_notes.update : true;
        },
        canDelete() {
            return true;
            // return authorizations.debit_notes ? !authorizations.debit_notes.delete : true;
        },
        hasOnlyOneSelected() {
            return this.selected.length === 1;
        },
        selectedDebitNote() {
            return isEmpty(this.selected) ? {} : this.selected[0];
        },
    },
    methods: {
        openDebitNoteDisplay() {
            this.debitNoteDisplayShown = true;
        },
        openDebitNoteDialogCreate() {
            this.selected = [];
            this.debitNoteDialogShown = true;
        },
        openDebitNoteDialogEdit() {
            this.debitNoteDialogShown = true;
        },
        refresh() {
            this.$refs.debitNoteDataTable.fetchDebitNoteData();
        },
        handleSearchMenuSubmit() {
            this.searchMenuShown = false;
            this.refresh();
        },
        // TODO: better show the loading state of deleting.
        deleteDebitNoteData() {
            deleteDebitNote(this.selectedDebitNote.id).then(() => {
                this.refresh();
            });
        },
        openAlertDialog({title, content, callback}) {
            this.alert = {...this.alert, display: true, title, content, callback};
        },
        confirmDeleting() {
            this.openAlertDialog({
                title: "Confirm Deleting",
                content: "Are you sure you want to delete this debit note! This action cannot be undone!",
                callback: this.deleteDebitNoteData
            })
        },
    }
};
</script>
